import { tabsClasses, TabsVariants } from "./Tabs.style";
import { Tabs as BaseTab } from "@base-ui-components/react/tabs";
import { TabContext } from "./TabContext";

export type TabsProps = TabsVariants & BaseTab.Root.Props;

export const Tabs = (props: TabsProps) => {
  const { className, children, ...rest } = props;
  return (
    <TabContext.Provider value={rest}>
      <BaseTab.Root
        className={tabsClasses({
          className: typeof className === "string" ? className : "",
        })}
        {...rest}
      >
        {children}
      </BaseTab.Root>
    </TabContext.Provider>
  );
};

Tabs.displayName = "Tabs";

export default Tabs;
